import ApiService from '@/utils/ApiService'
import getIdFromLink from '@/utils/getIdFromLink'

export default {
  namespaced: true,
  state: {
    isVisible: false,
    response: {}
  },
  getters: {
    isVisible: state => state.isVisible,
    response: state => state.response
  },
  mutations: {
    toggleModal (state) {
      state.isVisible = !state.isVisible
    },
    setResponse (state, payload) {
      state.response = payload
    }
  },
  actions: {
    async sendEmailProposition ({ commit, state }, params) {
      const response = await new ApiService(
        `e_x_a_b_agreements/${getIdFromLink(params.id)}/send_email_proposition`
      ).put(params.body)
      commit('setResponse', response)
    },
    async sendEmailPropositionForCollection ({ commit, state }, params) {
      const response = await new ApiService(
        `e_x_a_b_agreements/send_email_proposition_multi`
      ).post(params.body)
      commit('setResponse', response)
    }
  }
}
